export const useCreateQuestionMulti = (data) => {
  const questionOptions = []

  for (let i = 1; i <= 5; i++) {
    const optionKey = `pilihan_${i}`
    if (data[optionKey]) {
      questionOptions.push({
        name: data[optionKey],
        value: data[optionKey],
      })
      delete questionOptions[optionKey]
    }
  }

  return questionOptions
}
